/* Cascada Hydration Guide opt-ins.
   Every form posts to the GHL "CAS – 01 – Lead Magnet Intake" webhook with
   utm_source=website, utm_medium=<placement>, utm_campaign=hydration-guide.
   Bot filter (2026-10-19): submissions that fill the hidden cas_extra field, or
   arrive less than 3 seconds after the form loaded, get the normal success
   message but are never sent. Real signups carry form_key "cas-guide-2". */
(function () {
  if (window.__guideOptin) return;
  window.__guideOptin = true;

  var WEBHOOK = 'https://services.leadconnectorhq.com/hooks/zrvL7unrNcrEaSiFgaQa/webhook-trigger/c2460fc1-09c2-4849-90cc-fa70392137fb';
  var FORM_KEY = 'cas-guide-2';
  var MIN_FILL_MS = 3000;
  var DEST = {
    pdf: 'https://assets.cdn.filesafe.space/zrvL7unrNcrEaSiFgaQa/media/6ad1269e283355138e7bbb36.pdf',
    audio: 'https://guide.cascadaequine.com/listen'
  };
  var KEY_DONE = 'cascadaGuide:optedIn';
  var KEY_SNOOZE = 'cascadaGuide:snoozedUntil';

  function store(k, v) { try { v === undefined ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function hasCookie(n) { return document.cookie.indexOf(n + '=') > -1; }
  function setCookie(n, days) { document.cookie = n + '=1; max-age=' + days * 86400 + '; path=/; SameSite=Lax'; }

  function optedIn() { return read(KEY_DONE) === '1' || hasCookie('cas_guide_done'); }
  function snoozed() {
    var until = parseInt(read(KEY_SNOOZE) || '0', 10);
    return until > Date.now() || hasCookie('cas_guide_snooze');
  }

  function send(payload) {
    var body = JSON.stringify(payload);
    return fetch(WEBHOOK, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: body })
      .catch(function () {
        return fetch(WEBHOOK, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain' }, body: body });
      });
  }

  function initForm(form) {
    if (form.__ready) return;
    form.__ready = true;
    var fn = form.querySelector('[name="first_name"]');
    var em = form.querySelector('[name="email"]');
    var hp = form.querySelector('[name="cas_extra"]');
    var err = form.querySelector('.guide-optin__error');
    var loadedAt = Date.now();
    var busy = false;

    function valid() {
      var okName = fn.value.trim().length > 0;
      var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim());
      fn.setAttribute('aria-invalid', okName ? 'false' : 'true');
      em.setAttribute('aria-invalid', okEmail ? 'false' : 'true');
      err.hidden = okName && okEmail;
      return okName && okEmail;
    }

    function looksLikeBot() {
      if (hp && hp.value.trim() !== '') return true;
      if (Date.now() - loadedAt < MIN_FILL_MS) return true;
      return false;
    }

    function showDone() {
      var nameSlot = form.querySelector('[data-guide-name]');
      if (nameSlot) nameSlot.textContent = ', ' + fn.value.trim().split(' ')[0];
      form.classList.add('is-done');
      form.querySelector('.guide-optin__success').hidden = false;
    }

    function go(format) {
      if (busy || !valid()) return;
      busy = true;
      if (looksLikeBot()) { showDone(); return; }
      // Open the guide right away (inside the click) so pop-up blockers allow it.
      var win = window.open(DEST[format], '_blank');
      if (win) { try { win.opener = null; } catch (e) {} }
      var medium = form.getAttribute('data-medium') || 'website';
      send({
        first_name: fn.value.trim(),
        email: em.value.trim().toLowerCase(),
        guide_format: format,
        source: 'Hydration Guide opt-in',
        page_url: location.href,
        utm_source: 'website',
        utm_medium: medium,
        utm_campaign: 'hydration-guide',
        utm_content: location.pathname,
        form_key: FORM_KEY
      });
      store(KEY_DONE, '1');
      setCookie('cas_guide_done', 365);
      if (!win) {
        var p = form.querySelector('.guide-optin__success p:nth-of-type(2)');
        if (p) p.textContent = 'We emailed you both versions. You can also open them right here:';
      }
      showDone();
      if (window.dataLayer) window.dataLayer.push({ event: 'hydration_guide_optin', guide_format: format, placement: medium });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); go('pdf'); });
    form.querySelectorAll('[data-format]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); go(btn.getAttribute('data-format')); });
    });
    [fn, em].forEach(function (i) { i.addEventListener('input', function () { if (!err.hidden) valid(); }); });
  }

  /* ---------- popup ---------- */
  function initPopup() {
    var pop = document.querySelector('[data-guide-popup]');
    if (!pop || pop.__ready) return;
    pop.__ready = true;
    var form = pop.querySelector('[data-guide-optin]');
    var lastFocus = null;
    var shown = false;

    function open(medium) {
      if (pop.classList.contains('is-open')) return;
      if (medium && form) form.setAttribute('data-medium', medium);
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      document.body.classList.add('guide-popup-open');
      setTimeout(function () { var f = pop.querySelector('input'); if (f) f.focus({ preventScroll: true }); }, 350);
      shown = true;
    }
    function close() {
      pop.classList.remove('is-open');
      document.body.classList.remove('guide-popup-open');
      setTimeout(function () { pop.hidden = true; }, 300);
      if (!optedIn()) {
        var days = parseInt(pop.getAttribute('data-snooze-days') || '14', 10);
        store(KEY_SNOOZE, String(Date.now() + days * 86400000));
        setCookie('cas_guide_snooze', days);
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    pop.querySelectorAll('[data-guide-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });

    // Any link to #hydration-guide (or #hydration-guide=placement) opens the popup on any page.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#hydration-guide"]');
      if (!a) return;
      e.preventDefault();
      var m = (a.getAttribute('href').split('#hydration-guide=')[1] || 'link').split('&')[0];
      open(m);
    });

    var test = /[?&]guide-popup=test/.test(location.search);
    var auto = pop.getAttribute('data-auto') === 'true';
    if (!test && (!auto || optedIn() || snoozed())) return;
    if (!test && window.Shopify && Shopify.designMode) return; // never auto-open inside the theme editor

    var delay = parseInt(pop.getAttribute('data-delay') || '40', 10) * 1000;
    var minTime = 8000;
    var start = Date.now();
    function trigger() { if (!shown) open('popup'); }

    if (test) { setTimeout(trigger, 600); return; }

    // Desktop: exit intent (cursor leaves through the top of the window).
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && Date.now() - start > minTime) trigger();
    });
    // Phone: once they've scrolled most of the way through the page.
    if (window.matchMedia('(pointer: coarse)').matches) {
      window.addEventListener('scroll', function onScroll() {
        var depth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
        if (depth > 0.6 && Date.now() - start > minTime) { window.removeEventListener('scroll', onScroll); trigger(); }
      }, { passive: true });
    }
    // Fallback timer for everyone.
    setTimeout(trigger, delay);
  }

  /* ---------- footer: replace the old Shopify newsletter form with the guide opt-in ---------- */
  function swapFooter() {
    var old = document.getElementById('ContactFooter');
    var tpl = document.getElementById('GuideFooterOptin');
    if (!old || !tpl || !tpl.content) return;
    old.parentNode.replaceChild(tpl.content.cloneNode(true), old);
  }

  function boot() {
    swapFooter();
    document.querySelectorAll('[data-guide-optin]').forEach(initForm);
    initPopup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
